import React, { FC } from 'react';

import s from '../styles.scss';

export const HireProfessionalIconSvg: FC = () => (
  <svg
    className={s.svgIcon}
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57.53 29.1903L50.76 33.2603L49.46 31.1003L42.27 19.1003L41.15 17.2303L50.53 11.6003C45.287 5.72833 37.7805 2.38273 29.9085 2.40934C22.0366 2.43626 14.5529 5.83282 9.35001 11.7403L18.86 17.4603L17.73 19.3403L10.34 31.6703L9.25001 33.4903L2.47001 29.4103C2.46003 29.6068 2.46003 29.8037 2.47001 30.0003C2.47001 45.2157 14.8046 57.5503 30.02 57.5503C45.2355 57.5503 57.57 45.2157 57.57 30.0003C57.55 29.7303 57.55 29.4603 57.53 29.1903Z"
      fill="#C2E2FF"
    />
    <path
      d="M30.2 20.82L31.54 19.13L17.73 19.38L10.34 31.67L18.09 36.14L18.83 35.21L32.75 46.85L46.86 34.8L30.2 20.82Z"
      fill="#B37149"
    />
    <path
      d="M49.46 31.0996L42.27 19.0996L39.86 20.3096L34.53 18.6896C33.1486 18.2699 31.6587 18.3988 30.37 19.0496L23.47 22.5296C24.9429 25.0499 28.1188 25.9948 30.73 24.6896L33.26 23.4096L46 33.9996L49.46 31.0796V31.0996Z"
      fill="#FFB6AC"
    />
    <path
      d="M25.57 46.9804L10.76 35.2004L15.55 30.6104L30.46 41.8304L25.57 46.9804Z"
      fill="#FFB6AC"
    />
    <path
      d="M18.86 17.5003L17.73 19.3803L10.34 31.6703L9.24997 33.4903L2.46997 29.4103C2.58788 22.9013 5.02793 16.6486 9.34997 11.7803L18.86 17.5003Z"
      fill="white"
    />
    <path
      d="M57.53 29.1896L50.76 33.2596L49.46 31.0996L42.27 19.0996L41.15 17.2296L50.53 11.5996C54.8799 16.4445 57.3616 22.6806 57.53 29.1896Z"
      fill="#28BF9A"
    />
    <path
      d="M26.421 38.7253L27.1478 39.4121L22.3468 44.4926L21.62 43.8057L26.421 38.7253ZM28.7883 37.2298L36.4272 43.5898L35.7874 44.3583L28.1484 37.9983L28.7883 37.2298ZM22.4377 35.7265L23.1635 36.4143L18.4518 41.3864L17.7259 40.6986L22.4377 35.7265ZM31.5526 33.3919L40.125 40.4434L39.4898 41.2157L30.9173 34.1642L31.5526 33.3919ZM18.4706 32.7312L19.1969 33.4185L14.578 38.2995L13.8516 37.6121L18.4706 32.7312ZM34.2213 29.2723L43.7982 37.3055L43.1556 38.0717L33.5786 30.0385L34.2213 29.2723Z"
      fill="#192C55"
    />
  </svg>
);
